module.exports = __webpack_public_path__ + "img/collage1.bfd71af3.png";